// Lazy loaded components, make sure to wrap them with withSuspense and add fallback in the component export!
import AnimatedBannerWithBullets from 'components/Banner/AnimatedBannerWithBullets';
import BannerWithWallpaper from 'components/Banner/BannerWithWallpaper';
import BodyTextWithCTA from 'components/Banner/BodyTextWithCTA';
import BodyTextWithDoubleCTA from 'components/Banner/BodyTextWithDoubleCTA';
import BodyTextWithMarketingProperties from 'components/Banner/BodyTextWithMarketingProperties';
import HeaderBannerWithDynamicSlider from 'components/Banner/HeaderBannerWithDynamicSlider';
import ImageAndCTA from 'components/Banner/ImageAndCTA';
import BlocksOnBackground from 'components/BlocksOnBackground';
import BlocksWithTicks from 'components/BlocksWithTicks';
import BodyTextSlider from 'components/BodyTextSlider';
import ClickableHowTo from 'components/ClickableHowTo';
import HubCards from 'components/Colors/HubCards';
import Fonts from 'components/Fonts';
import Sizes from 'components/Sizes';
import Links from 'components/Colors/Links';
import ComparisonTable from 'components/ComparisonTable';
import FAQ from 'components/FAQ';
import FeaturedInWithLogos from 'components/FeaturedInWithLogos';
import GridWithTemplates from 'components/GridWithTemplates';
import SummaryContent from 'components/SummaryContent';
import SizeCalculate from 'components/Sizes/components/SizeCalculate';
import HowToIcons from 'components/HowToIcons';
import HowToOldVersion from 'components/HowToOldVersion';
import IconBlockWithCTAs from 'components/IconBlockWithCTAs';
import ImageAndBulletList from 'components/ImageAndBulletList';
import ImageSliderWithCTA from 'components/ImageSliderWithCTA';
import ImageSliderWithDynamicTemplates from 'components/ImageSliderWithDynamicTemplates';
import ImageSliderWithThumbnailCarousel from 'components/ImageSliderWithThumbnailCarousel';
import InteractiveImages from 'components/InteractiveImages';
import ListWithPaginationAndCTA from 'components/ListWithPaginationAndCTA';
import ListWithTicks from 'components/ListWithTicks';
import TestimonialWithCardDesign from 'components/TestimonialWithCardDesign';
import TestimonialWithCardDesignAndTitle from 'components/TestimonialWithCardDesignAndTitle';
import TestimonialWithTitles from 'components/TestimonialWithTitles';
import TextInBoxDesign from 'components/TextInBoxDesign';
import ThumbnailsUrlWithHeaderAndDescription from 'components/ThumbnailsUrlWithHeaderAndDescription';
import UseCaseWithToggle from 'components/UseCaseWithToggle';
import BannerBlock from 'redesignedComponents/sections/BannerBlock';
import BannerBlockCarousel from 'redesignedComponents/sections/BannerBlockCarousel';
import BannerCarousel from 'redesignedComponents/sections/BannerCarousel';
import MoreToolsToExplore from 'redesignedComponents/sections/MoreToolsToExplore';
import PricingCards from 'components/PricingCards';

// Eager loaded components that need no skeleton and lazy loading/suspense
import ErrorNotFound from 'components/ErrorNotFound';
import Divider from 'redesignedComponents/sections/Divider';
// widely used components
import BannerWithImage from 'components/Banner/BannerWithImage';
import BodyTextsContainer from 'components/BodyTextsContainer';
import IntroText from 'components/IntroText';
import Templates from 'redesignedComponents/sections/Templates';

import HeaderBannerWithCTAAndBullets from 'components/Banner/HeaderBannerWithCTAAndBullets';
import BrandCarousel from 'components/BrandCarousel';
import BrandsControlledCarousel from 'components/BrandsControlledCarousel';
import Grid from 'components/BrandsControlledCarousel/Grid';
import BrandsFreeToEdit from 'components/BrandsFreeToEdit';
import BrandsModalWrapper from 'components/BrandsModalWrapper';
import BrandsStats from 'components/BrandsStats';
import BrandsTexts from 'components/BrandsTexts';
import HubsGrid from 'components/HubsGrid';
import Spotlights from 'components/Spotlights';
import StickyBar from 'components/StickyBar';
import YoutubeVideo from 'components/YoutubeVideo';
import EmbeddedVideo from 'redesignedComponents/sections/EmbeddedVideo';
import InThePress from 'redesignedComponents/sections/InThePress';

import BarcodeSection from 'components/BarcodeSection';
import CoverSection from 'components/CoverSection';
import DesignForSection from 'components/DesignForSection';
import ExploreBanner from 'components/ExploreBanner';
import ImageSliderWithCtaHome from 'components/ImageSliderWithCTAHome';
import PressCarousel from 'components/PressCarousel';
import Summary from 'components/Summary';
import TestimonialsCarousel from 'components/TestimonialsCarousel';
import Texts from 'components/Texts';
import WhyUs from 'components/WhyUs';
import AppDownloadSection from 'pages/NewHome/sections/AppDownloadSection';
import BannerWithCTA from 'pages/NewHome/sections/BannerWithCTA';
import DesignForUseCases from 'pages/NewHome/sections/DesignForUseCases';
import HomeTopSection from 'pages/NewHome/sections/HomeTopSection';
import PageLinkingComponent from 'pages/NewHome/sections/PageLinkingComponent';
import PricingCardsSection from 'pages/NewHome/sections/PricingCardsSection';
import ReviewScroller from 'pages/NewHome/sections/ReviewScroller';
import StartForFree from 'pages/NewHome/sections/StartForFree';
import TrustBox from 'pages/NewHome/sections/TrustBox';
import SuggestedTemplates from 'redesignedComponents/organisms/SuggestedTemplates';
import AllTools from 'redesignedComponents/sections/AllTools';
import ExploreSimilarPages from 'redesignedComponents/sections/ExploreSimilarPages';
import RedesignedFAQ from 'redesignedComponents/sections/FAQ';
import HowTo from 'redesignedComponents/sections/HowTo';
import Rating from 'redesignedComponents/sections/Rating';
import RedesignedSummary from 'redesignedComponents/sections/Summary';
import UseCases from 'redesignedComponents/sections/UseCases';
import ValueItemisation from 'redesignedComponents/sections/ValueItemisation';
import { TemplateBannerCarousel } from 'templates/components';
import TemplatesCategoryCarousel from 'components/TemplatesCategoryCarousel';
import CardsSection from 'components/CardsSection';
// Colors
import ColorMeanings from 'components/ColorMeanings';
import ColorPickerBanner from 'components/Colors/ColorPickerBanner';
import ColorBanner from 'components/Colors/ColorBanner';
import ColorWithText from 'components/Colors/ColorWithText';
import TitleWithDescription from 'components/Colors/TitleWithDescription';
import ColorDetails from 'components/Colors/ColorDetails';
import ColorTemplates from 'components/Colors/ColorTemplates';
import ColorsByCategory from 'components/Colors/ColorsByCategory';
import ClickableImageWithTextList from 'components/Colors/ClickableImageWithTextList';
import FeatureList from 'components/FeatureList';
import BannerWithSearch from 'components/Banner/BannerWithSearch';
import WidgetExperiment from 'components/WidgetExperiment';
import SizesPostList from 'components/Sizes/components/SizesPostList/SizesPostList';
import TemplatesCategories from 'templates/pages/Categories/Categories';
import AnimatedCards from '../components/AnimatedCards';

export default {
  ThumbnailsUrlWithHeaderAndDescription,
  TestimonialWithCardDesignAndTitle,
  ImageSliderWithThumbnailCarousel,
  BodyTextWithMarketingProperties,
  ImageSliderWithDynamicTemplates,
  HeaderBannerWithCTAAndBullets,
  HeaderBannerWithDynamicSlider,
  ClickableImageWithTextList,
  AnimatedBannerWithBullets,
  TestimonialWithCardDesign,
  BrandsControlledCarousel,
  ListWithPaginationAndCTA,
  ImageSliderWithCtaHome,
  TestimonialWithTitles,
  BodyTextWithDoubleCTA,
  TemplatesCategories,
  TitleWithDescription,
  BannerBlockCarousel,
  FeaturedInWithLogos,
  BannerWithWallpaper,
  ImageSliderWithCTA,
  MoreToolsToExplore,
  ImageAndBulletList,
  BlocksOnBackground,
  BrandsModalWrapper,
  BodyTextsContainer,
  IconBlockWithCTAs,
  GridWithTemplates,
  ColorPickerBanner,
  UseCaseWithToggle,
  InteractiveImages,
  ColorsByCategory,
  BrandsFreeToEdit,
  BlocksWithTicks,
  ComparisonTable,
  TextInBoxDesign,
  BodyTextWithCTA,
  HowToOldVersion,
  BannerWithImage,
  BodyTextSlider,
  ClickableHowTo,
  SummaryContent,
  ColorTemplates,
  SizeCalculate,
  ColorWithText,
  ErrorNotFound,
  BrandCarousel,
  ListWithTicks,
  EmbeddedVideo,
  YoutubeVideo,
  ColorDetails,
  PricingCards,
  ColorBanner,
  ImageAndCTA,
  BrandsStats,
  BrandsTexts,
  Spotlights,
  HowToIcons,
  StickyBar,
  IntroText,
  HubCards,
  HubsGrid,
  Summary,
  Rating,
  Fonts,
  Sizes,
  SizesPostList,
  WhyUs,
  Texts,
  Links,
  Grid,
  FAQ,
  ColorMeanings,
  BannerBlock,
  HowTo,
  RedesignedSummary,
  RedesignedFAQ,
  ValueItemisation,
  Divider,
  UseCases,
  Templates,
  TestimonialsCarousel,
  PressCarousel,
  BarcodeSection,
  CoverSection,
  ExploreBanner,
  DesignForSection,
  InThePress,
  HomeTopSection,
  TrustBox,
  DesignForUseCases,
  BannerWithCTA,
  ReviewScroller,
  AppDownloadSection,
  PricingCardsSection,
  PageLinkingComponent,
  StartForFree,
  ExploreSimilarPages,
  BannerCarousel,
  AllTools,
  SuggestedTemplates,
  BannerWithSearch,
  TemplateBannerCarousel,
  FeatureList,
  WidgetExperiment,
  TemplatesCategoryCarousel,
  CardsSection,
  AnimatedCards,
};
